import type { CatalogCategory } from '@/lib/api/catalog/catalog-api'
import { getServiceLabels, type ServiceLabels } from '@/lib/form-state/util'
import { useAuth } from '@/store/hooks'

/**
 * Vocabulário do tipo de atendimento da empresa logada.
 * Fora da saúde: Procedimento -> Pedido, Consulta -> Avaliação.
 *
 * `isHealth` serve também como gate para os campos clínicos (TUSS, hospital,
 * anestesista, instruções do exame).
 */
export function useServiceLabel(): ServiceLabels {
    const { user } = useAuth()

    return getServiceLabels(user?.company?.segment)
}

/**
 * `CATALOG_CATEGORY_LABELS` traduzido para o segmento. Use no lugar da constante
 * sempre que o rótulo for exibido ao operador (abas, dropdowns, badges).
 */
export function useCatalogCategoryLabels(): Record<CatalogCategory, string> {
    const labels = useServiceLabel()

    return {
        EXAM: labels.Exam,
        PROCEDURE: labels.Order,
        CONSULTATION: labels.Consultation,
        TELECONSULTATION: labels.Teleconsultation,
        PACKAGE: 'Pacote',
        // "Produto" é produto em qualquer segmento — não passa por tradução.
        PRODUCT: 'Produto',
    }
}
